const stringUnion = <UnionType extends string>(...values: UnionType[]) => {
    Object.freeze(values);
    const valueSet: Set<string> = new Set(values);
    const en = values.reduce((en: any, v) => {
        en[v.toUpperCase()] = v;
        return en;
    }, {});

    const guard = (value: string): value is UnionType => {
        return valueSet.has(value);
    };

    const check = (value: string): UnionType => {
        if (!guard(value)) {
            const actual = JSON.stringify(value);
            const expected = values.map(s => JSON.stringify(s)).join(' | ');
            throw new TypeError(`Value '${actual}' is not assignable to type '${expected}'.`);
        }
        return value;
    };

    const unionNamespace = {guard, check, values, enum: en};
    return Object.freeze(unionNamespace as typeof unionNamespace & {type: UnionType});
};

export default stringUnion;
